module.exports = __webpack_public_path__ + "static/media/play-btn-new.eeec2079.png";